import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'hero-image' || groupKey === 'feature-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

const splitTitleLines = (title) =>
  (title || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

export const parseInsightsHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    titleLines: splitTitleLines(fields.title),
    text: fields.text || '',
    image: getMediaUrl(section, 'hero-image'),
  };
};

export const parseInsightsPillarsContent = (page) => {
  const section = getSection(page, 'pillars');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
      cta: {
        text: fields[`item-${index}-ctaText`] || '',
        url: fields[`item-${index}-ctaUrl`] || '#',
      },
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || '',
    items,
  };
};

export const parseInsightsFeaturedContent = (page) => {
  const section = getSection(page, 'featured');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/insights/market-analysis',
    },
    card: {
      tag: fields.tag || '',
      title: fields.cardTitle || '',
      text: fields.cardText || '',
      link: {
        text: fields.cardLinkText || '',
        url: fields.cardLinkUrl || '/insights/market-analysis',
      },
    },
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseInsightsNewsContent = (page) => {
  const section = getSection(page, 'news');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/insights/market-analysis',
    },
  };
};

export const parseInsightsSubscribeContent = (page) => {
  const section = getSection(page, 'subscribe');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    buttonText: fields.buttonText || 'Subscribe',
    privacy: {
      text: fields.privacyText || '',
      linkText: fields.privacyLinkText || 'privacy policy',
      linkUrl: fields.privacyLinkUrl || '/privacy',
    },
  };
};

export const parseInsightsHeritageContent = (page) => {
  const section = getSection(page, 'heritage');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
  };
};
